module.exports = __webpack_public_path__ + "static/media/clark-street-mercantile.f4d70074.jpg";